'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flattenProp = require('recompose/flattenProp');

var _flattenProp2 = _interopRequireDefault(_flattenProp);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _lifecycle = require('recompose/lifecycle');

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _queueHandlersAfter = require('coact-utils/queueHandlersAfter');

var _queueHandlersAfter2 = _interopRequireDefault(_queueHandlersAfter);

var _queueHandlersBefore = require('coact-utils/queueHandlersBefore');

var _queueHandlersBefore2 = _interopRequireDefault(_queueHandlersBefore);

var _renderAfter = require('coact-utils/renderAfter');

var _renderAfter2 = _interopRequireDefault(_renderAfter);

var _bindHotKeys = require('coact-utils/bindHotKeys');

var _bindHotKeys2 = _interopRequireDefault(_bindHotKeys);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

var _createBySchema = require('../../../utils/creation/createBySchema');

var _createBySchema2 = _interopRequireDefault(_createBySchema);

var _validateBySchema = require('../../../utils/validation/validateBySchema');

var _validateBySchema2 = _interopRequireDefault(_validateBySchema);

var _stopDuplicateAction = require('./stopDuplicateAction');

var _stopDuplicateAction2 = _interopRequireDefault(_stopDuplicateAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function alertError(message) {
  // eslint-disable-next-line no-alert
  window.alert('!!!!!!!!!!!!!!!!!!!!\n' + '!!!!!!!!!!!!!!!!!!!!\n' + (message + '\n') + '!!!!!!!!!!!!!!!!!!!!\n' + '!!!!!!!!!!!!!!!!!!!!\n' + '');
}
var loadDoc = function loadDoc(_ref) {
  var editType = _ref.editType,
      initDoc = _ref.initDoc,
      findDoc = _ref.findDoc,
      copyDoc = _ref.copyDoc;
  return function () {
    if (editType === 'create') return initDoc();
    if (editType === 'copy') return copyDoc();
    return findDoc();
  };
};

var saveEditing = function saveEditing(_ref2) {
  var editType = _ref2.editType,
      insertDoc = _ref2.insertDoc,
      updateDoc = _ref2.updateDoc,
      value = _ref2.value;
  return function () {
    if (editType === 'create' || editType === 'copy') return insertDoc(value);
    return updateDoc(value);
  };
};

var cancelEditing = function cancelEditing(_ref3) {
  var gotoDocList = _ref3.gotoDocList;
  return function () {
    return gotoDocList();
  };
};

var routeToNewDoc = function routeToNewDoc(_ref4) {
  var gotoCreateDoc = _ref4.gotoCreateDoc;
  return function () {
    return gotoCreateDoc();
  };
};

var afterLoad = function afterLoad(_ref5) {
  var onChange = _ref5.onChange,
      emitter = _ref5.emitter;
  return function (newValue) {
    return new Promise(function (resolve) {
      return onChange(newValue, function () {
        resolve(newValue);
        emitter.emit('loadDone');
      });
    });
  };
};

// this implement, error instanceof ValidationError is false
// class ValidationError extends Error {
//   constructor (message) {
//     super(message)
//     this.name = 'ValidationError'
//   }
// }
function ValidationError(message) {
  this.name = 'ValidationError';
  this.message = message;
  this.stack = new Error().stack;
}
ValidationError.prototype = new Error();

function buildValidationMessage(validation) {
  var messages = Object.keys(validation).reduce(function (arr, key) {
    if (!validation[key]) return arr;
    arr.push(validation[key]);
    return arr;
  }, []);

  return messages.length === 0 ? false : messages;
}

var shape = _propTypes2.default.shape,
    func = _propTypes2.default.func,
    object = _propTypes2.default.object,
    string = _propTypes2.default.string;

var enhancer = (0, _composeWithScope2.default)((0, _getContext2.default)({
  emitter: object,
  server: object.isRequired
}), (0, _consumeProps2.default)({
  auth: shape({
    user: object
  }),
  db: shape({
    findDoc: func.isRequired,
    insertDoc: func.isRequired,
    updateDoc: func.isRequired
  }),
  page: shape({
    docId: string,
    editType: string.isRequired,
    gotoCreateDoc: func.isRequired,
    gotoCopyDoc: func.isRequired,
    gotoDocList: func.isRequired,
    replaceDocId: func.isRequired
  })
}), (0, _injectProps2.default)({
  value: object,
  onChange: func.isRequired,
  schema: object
}),

// ISSUE use flattenDefaultProp?
(0, _flattenProp2.default)('db'), (0, _flattenProp2.default)('page'), (0, _withHandlers2.default)({
  initDoc: function initDoc(_ref6) {
    var schema = _ref6.schema,
        user = _ref6.auth.user,
        server = _ref6.server;
    return function () {
      return (0, _createBySchema2.default)(schema, { user: user, server: server });
    };
  },
  copyDoc: function copyDoc(_ref7) {
    var schema = _ref7.schema,
        user = _ref7.auth.user,
        server = _ref7.server,
        value = _ref7.value;
    return function () {
      return (0, _createBySchema2.default)(schema, { user: user, server: server }, value);
    };
  },
  validateDoc: function validateDoc(_ref8) {
    var schema = _ref8.schema;
    return (0, _validateBySchema2.default)(schema);
  }
}), (0, _withHandlers2.default)({
  loadDoc: loadDoc,
  saveEditing: saveEditing,
  cancelEditing: cancelEditing,
  routeToNewDoc: routeToNewDoc
}), (0, _withHandlers2.default)((0, _queueHandlersBefore2.default)({
  saveEditing: function saveEditing(_ref9) {
    var validateDoc = _ref9.validateDoc,
        value = _ref9.value;
    return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
      var result, messages;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              result = validateDoc(value);
              messages = buildValidationMessage(result);

              if (!messages) {
                _context.next = 4;
                break;
              }

              throw new ValidationError(messages.join('\n'));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));
  }
})), (0, _withHandlers2.default)((0, _queueHandlersBefore2.default)({
  saveEditing: function saveEditing(_ref11) {
    var emitter = _ref11.emitter;
    return _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return emitter.finish('endEditing');

            case 2:
              _context2.next = 4;
              return emitter.finish('cleanEditing');

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));
  }
})), (0, _withHandlers2.default)({
  saveEditing: function saveEditing(_ref13) {
    var action = _ref13.saveEditing;
    return _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
      var savedValue, contentType, _ref15, message, statusText;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return action();

            case 3:
              savedValue = _context3.sent;


              // eslint-disable-next-line no-alert
              window.alert('儲存完成');

              return _context3.abrupt('return', savedValue);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3['catch'](0);

              alertError('儲存失敗');

              if (!(_context3.t0 instanceof ValidationError)) {
                _context3.next = 15;
                break;
              }

              // eslint-disable-next-line no-alert
              alertError(_context3.t0.message);
              _context3.next = 27;
              break;

            case 15:
              console.log(_context3.t0);
              contentType = _context3.t0.headers.get('Content-Type');

              if (!(contentType && contentType.indexOf('application/json') !== -1)) {
                _context3.next = 25;
                break;
              }

              _context3.next = 20;
              return _context3.t0.json();

            case 20:
              _ref15 = _context3.sent;
              message = _ref15.message;

              alertError(message);
              _context3.next = 27;
              break;

            case 25:
              statusText = _context3.t0.statusText;

              alertError(statusText);

            case 27:
              throw new Error('save fail');

            case 28:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined, [[0, 8]]);
    }));
  }
}), (0, _withHandlers2.default)((0, _queueHandlersAfter2.default)({
  loadDoc: afterLoad,
  saveEditing: afterLoad
})), (0, _withHandlers2.default)((0, _queueHandlersAfter2.default)({
  saveEditing: function saveEditing(_ref16) {
    var replaceDocId = _ref16.page.replaceDocId;
    return function (newValue) {
      // TODO await replaceDocId finish
      replaceDocId(newValue._id);
      return newValue;
    };
  }
})), (0, _lifecycle2.default)({
  componentDidMount: function componentDidMount() {
    this.props.loadDoc();
  },


  // 在 willReceivePorps 或 shouldComponentUpdate 檢查是否需要重 load 資料
  // 也許在需要重 load 資料的時候，不做 update?
  // 考慮在更上層算出 isReloadDoc? 為 true 時，先 render null，重 load 後再 render
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var value = nextProps.value,
        docId = nextProps.docId;

    // create 時 value._id 會是 tempId 不是 null 不好比較
    // routeDocId 改變時，或 routeDocId 與 data._id 不一樣時

    if (this.props.docId !== docId && value._id !== docId) {
      nextProps.loadDoc();
    }
  }
}), (0, _renderAfter2.default)(function (_ref17) {
  var value = _ref17.value;
  return !!value;
}),

// TODO control actions flow, error handling
(0, _stopDuplicateAction2.default)('saveEditing'), (0, _withHandlers2.default)({
  routeToNewDoc: function routeToNewDoc(_ref18) {
    var route = _ref18.routeToNewDoc,
        save = _ref18.saveEditing;
    return function () {
      return save().then(route);
    };
  },
  routeToCopyDoc: function routeToCopyDoc(_ref19) {
    var gotoCopyDoc = _ref19.gotoCopyDoc,
        save = _ref19.saveEditing;
    return function () {
      return save().then(gotoCopyDoc);
    };
  },
  cancelEditing: function cancelEditing(_ref20) {
    var cancel = _ref20.cancelEditing;
    return function () {
      // eslint-disable-next-line no-alert
      if (window.confirm('是否真的要離開')) {
        cancel();
      }
    };
  }
}), (0, _bindHotKeys2.default)({
  routeToNewDoc: 'ctrl+b',
  saveEditing: 'ctrl+enter',
  cancelEditing: 'ctrl+q'
}), (0, _bindHotKeys2.default)({
  routeToNewDoc: 'ctrl+alt+n'
}), (0, _exposeProps2.default)(['saveEditing', 'cancelEditing', 'routeToNewDoc', 'routeToCopyDoc', 'gotoCreateDoc', 'gotoDocList']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'controlEditor');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/controlEditor/index.js
// module id = 1705
// module chunks = 0